import React from 'react';
import { motion } from 'framer-motion';
import { HOVER_SPRING } from '../../../utils/motion';
export function KordisVisual() {
  return <div aria-hidden className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-night px-6" data-id="element-415" data-mp="3clh2d6q81n0v">
      <div className="rounded-full bg-white/10 px-4 py-2 text-xs text-white/85" data-id="element-416" data-mp="3qhb2b090p21u">
        Why did gross margin drop in March?
      </div>
      <motion.div className="w-full max-w-sm rounded-xl bg-white p-3.5" data-id="element-417" data-mp="4bnulwfpku7w">
        <div className="h-2 w-11/12 rounded-full bg-line" data-id="element-418" data-mp="49uqanskim32" />
        <div className="mt-2 h-2 w-3/4 rounded-full bg-line" data-id="element-419" data-mp="3vhp7maj8hxw6" />
        <div className="mt-3 flex flex-wrap gap-1.5 text-[10px] font-medium" data-id="element-420" data-mp="d50x9q3kra76">
          <span className="rounded bg-ink-soft px-1.5 py-0.5 text-ink" data-id="element-421" data-mp="92w56vsrylmn">Source 1</span>
          <span className="rounded bg-ink-soft px-1.5 py-0.5 text-ink" data-id="element-422" data-mp="959yp07t3ps3">Source 2</span>
          <span className="rounded bg-coral-soft px-1.5 py-0.5 text-rust" data-id="element-423" data-mp="n2yjk81viwx5">Moderate confidence</span>
        </div>
      </motion.div>
    </div>;
}